import React from 'react'

import { TextField } from '@masfront/common-b2c'
import { FastField } from 'formik'

import { Typography, Box, Grid, MenuItem } from '@material-ui/core'

export default function ClientInfo({ hoursOptions, shouldShowHours }: any) {
  return (
    <>
      <Box my={6}>
        <Typography variant="subtitle2" color="textSecondary">
          DATOS DEL CLIENTE
        </Typography>
      </Box>
      <Grid container component={Box} spacing={5}>
        <Grid xs={4} item>
          <FastField
            fullWidth
            component={TextField}
            name="name"
            label="Nombre"
            variant="outlined"
          />
        </Grid>
        <Grid xs={4} item>
          <FastField
            fullWidth
            component={TextField}
            name="surname1"
            label="Primer Apellido"
            variant="outlined"
          />
        </Grid>
        <Grid xs={4} item>
          <FastField
            fullWidth
            component={TextField}
            name="sellerCode"
            label="Código vendedor"
            variant="outlined"
          />
        </Grid>
      </Grid>
      <Grid container component={Box} spacing={5}>
        <Grid xs={4} item>
          <FastField
            fullWidth
            component={TextField}
            name="telephoneNumber"
            label="Teléfono de contacto"
            variant="outlined"
            inputProps={{
              maxLength: 9,
            }}
          />
        </Grid>
        {shouldShowHours && (
          <Grid xs={4} item>
            <FastField
              fullWidth
              component={TextField}
              name="contactHour"
              variant="outlined"
              label="Programación de contacto"
              select
            >
              {hoursOptions.map((elem: any) => {
                return (
                  <MenuItem key={elem.key} value={elem.value} disabled={elem.disabled}>
                    {elem.label}
                  </MenuItem>
                )
              })}
            </FastField>
          </Grid>
        )}
      </Grid>
    </>
  )
}
